/**
 * Central registry of Sentinel permission strings ("resources"), grouped by
 * feature into one enum each.
 *
 * Each value must match the cdm-mw `Permission` constant
 * (`com.nyse.core.constant.Permission.*`) and the Sentinel grant resource name
 * byte-for-byte — they are a cross-system contract. Centralizing them here gives
 * the UI a single source of truth to align against the backend, instead of
 * scattering bare string literals across pages and route configs.
 *
 * Follows the typed-enum idiom already used by `tradeSummary.resource.ts`
 * (`enum Permissions`). New features should add a `<Feature>Permissions` enum
 * here rather than inlining literals at the call site.
 */
export enum MmAppointmentPermissions {
    view = 'view mm appointments',
    create = 'create mm appointments',
    delete = 'delete mm appointments'
}

export enum SymbolMpidClearingPermissions {
    view = 'view symbol mpid clearing',
    create = 'create symbol mpid clearing',
    delete = 'delete symbol mpid clearing'
}
